module.exports = __webpack_public_path__ + "static/media/icon_rotate_right.45fe4b21.svg";